import AOS from 'aos';
import 'aos/dist/aos.css';

const initializeAOS = () => {
  AOS.init({
    once: true, // Initialize AOS with once option set to true
  });
};

export default initializeAOS;